import EventBus from '../services/service.eventBus';
import { getAllOptimizelyVariables } from '../services/service.optimizely';
import { state as landingState } from '../store/store.landing';

import { actions as pageParamsActions } from './actions.page-params';

const onReceivedParams = ({ installationMode, category }) => {
  try {
    onReceivedParamsSuccess({ installationMode, category });
  } catch (error) {
    onReceivedParamsFail(error);
  }
};
const onReceivedParamsSuccess = ({ installationMode, category }) => {
  EventBus.publish('ReceivedParams', { installationMode, category });
  landingState.installationMode = installationMode;
  pageParamsActions.onReceivedTrackingCategory(category);
  EventBus.publish('ReceivedParamsSuccess', {});
};

const onReceivedParamsFail = (error) => {
  EventBus.publish('ReceivedParamsFail', error);
};

const onStoreUpdate = (props = {}) => {
  Object.entries(props).forEach(([name, value]) => {
    landingState[name] = value;
  });
};

const UNASSIGNED_MAIN_TITLE_FEATURE = 'unassignedmaintitlecomponent';
const VIDEO_COMPONENT = 'videocomponent';
const CONTACT_US_COMPONENT = 'contactuscomponent';
const STEP_BY_STEP_COMPONENT = 'stepbystepcomponent';
const LANDING_FAQ_COMPONENT = 'faqscomponent';
const LANDING_LEGAL_COMPONENT = 'legalcomponent';

const FEATURES = {
  [UNASSIGNED_MAIN_TITLE_FEATURE]: { subCopy: '', header: '' },
  [VIDEO_COMPONENT]: {},
  [CONTACT_US_COMPONENT]: {},
  [STEP_BY_STEP_COMPONENT]: { LandingUnassigned: {} },
  [LANDING_FAQ_COMPONENT]: { faqTitle: '', faqData: '' },
  [LANDING_LEGAL_COMPONENT]: {},
};

const onOptimizelyFetching = async () => {
  try {
    await onOptimizelyFetchingSuccess();
  } catch (error) {
    onOptimizelyFetchingFail(error);
  }
};

const onOptimizelyFetchingSuccess = async () => {
  EventBus.publish('OptimizelyFetching', {});
  const optimizelyVariables = await getAllOptimizelyVariables(Object.keys(FEATURES), landingState.dealerId);
  Object.keys(FEATURES).forEach((featureName) => {
    const feature = optimizelyVariables.find((x) => x.featureName == featureName);
    if (feature && feature.variables) {
      Object.assign(FEATURES[featureName], JSON.parse(feature.variables));
    }
  });

  onStoreUpdate({
    unassignedMainTitleSubCopy: FEATURES[UNASSIGNED_MAIN_TITLE_FEATURE].subCopy,
    unassignedMainTitleHeader: FEATURES[UNASSIGNED_MAIN_TITLE_FEATURE].header,
    unAssignedStepByStep: FEATURES[STEP_BY_STEP_COMPONENT].LandingUnassigned,
    faqTitle: FEATURES[LANDING_FAQ_COMPONENT].faqTitle,
    faqData: FEATURES[LANDING_FAQ_COMPONENT].faqData,
    videoComponent: FEATURES[VIDEO_COMPONENT],
    contactUsComponent: FEATURES[CONTACT_US_COMPONENT],
    legalContents: FEATURES[LANDING_LEGAL_COMPONENT],
  });

  EventBus.publish('OptimizelyFetchingSuccess', { FEATURES });
};

const onOptimizelyFetchingFail = (error) => {
  EventBus.publish('OptimizelyFetchingFail', error);
};

export default {
  onReceivedParams,
  onOptimizelyFetching,
  onStoreUpdate,
};
